// Dependencies
import styled, { css } from "styled-components";

// Types
import { ActivityChipSizes, ActivityChipVariants } from "./activity-chip.types";

// Utils
import { theme } from "config/theme";

export type ContainerStyleProps = {
    variant: ActivityChipVariants;
    hasCursorPointer?: boolean;
    size: ActivityChipSizes;
};

export const Container = styled.div<ContainerStyleProps>`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;

    width: max-content;
    border: 1px solid;
    border-radius: 200px;

    ${({ size }) =>
        size === "small" &&
        css`
            padding: 4px 10px;
        `}

    ${({ size }) =>
        size === "large" &&
        css`
            padding: 8px 16px;
        `}


    ${({ hasCursorPointer }) =>
        !!hasCursorPointer &&
        css`
            cursor: pointer;
        `}

    ${({ variant }) =>
        variant === "disabled" &&
        css`
            background-color: ${theme.colors.base[200]};
            border-color: ${theme.colors.base[200]};
        `}

    ${({ variant }) =>
        variant === "info" &&
        css`
            background-color: ${theme.colors.system.info[100]};
            border-color: ${theme.colors.system.info[100]};
        `}

    ${({ variant }) =>
        variant === "success" &&
        css`
            background-color: ${theme.colors.system.success[100]};
            border-color: ${theme.colors.system.success[100]};
        `}

    ${({ variant }) =>
        variant === "danger" &&
        css`
            background-color: ${theme.colors.system.danger[100]};
            border-color: ${theme.colors.system.danger[100]};
        `}

    ${({ variant }) =>
        variant === "warning" &&
        css`
            background-color: ${theme.colors.system.warning[100]};
            border-color: ${theme.colors.system.warning[100]};
        `}

    ${({ variant }) =>
        variant === "cta" &&
        css`
            background-color: ${theme.colors.brand[500]};
            border-color: ${theme.colors.brand[500]};
        `}

    ${({ variant }) =>
        variant === "default" &&
        css`
            background-color: transparent;
            border-color: ${theme.colors.base[200]};
        `}
`;

type LabelStyleProps = {
    color: string;
    size: ActivityChipSizes;
};

export const Label = styled.p<LabelStyleProps>`
    font-family: "Nunito", sans-serif;
    letter-spacing: 0em;
    text-align: center;

    ${({ color }) =>
        !!color &&
        css`
            color: ${color};
        `}

    ${({ size }) =>
        size === "small" &&
        css`
            font-size: 12px;
            font-weight: 700;
            line-height: 16px;
        `}

    ${({ size }) =>
        size === "large" &&
        css`
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
        `}
`;
